// extracted by mini-css-extract-plugin
export default {"avatarLink":"xJ9iUNzAaAt_jmR0Xn2n"};